"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFieldDataType = void 0;
var CustomFieldDataType;
(function (CustomFieldDataType) {
    CustomFieldDataType[CustomFieldDataType["Text"] = 1] = "Text";
    CustomFieldDataType[CustomFieldDataType["Number"] = 2] = "Number";
    CustomFieldDataType[CustomFieldDataType["Date"] = 3] = "Date";
    CustomFieldDataType[CustomFieldDataType["Date/Time"] = 4] = "Date/Time";
    CustomFieldDataType[CustomFieldDataType["True/False"] = 5] = "True/False";
    CustomFieldDataType[CustomFieldDataType["Pick List"] = 6] = "Pick List";
    CustomFieldDataType[CustomFieldDataType["Hyperlink"] = 7] = "Hyperlink";
})(CustomFieldDataType = exports.CustomFieldDataType || (exports.CustomFieldDataType = {}));
//# sourceMappingURL=CustomFieldDataType.js.map